import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-standalone-layout _flexcol _jc-c _ai-c" }
const _hoisted_2 = { class: "_pb-9" }
const _hoisted_3 = {
  class: "_my-3 _tac _px-8",
  "data-qa": "payment-error:Description"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  class: "_my-3 _tac _px-8",
  "data-qa": "payment-error:Description"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_base_button = _resolveComponent("base-button")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_box, { class: "_flexcol _jc-c _ai-c" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon, {
            name: "times-circle",
            size: "4x",
            class: "_tc--error _lh-1 _mb-2"
          }),
          _createVNode(_component_base_heading, {
            tag: "h2",
            "data-qa": "payment-error:Title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.PaymentErrorBoxTitle), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          ($options.isAuthenticated)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.Checkout.PaymentErrorBoxDescription), 1 /* TEXT */),
                _createVNode(_component_base_button, {
                  tag: "a",
                  theme: "accent",
                  onClick: $options.onGoToCheckout,
                  "data-qa": "payment-error:GoToCheckoutButton"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.PaymentErrorGoToCheckoutLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _createElementVNode("a", {
                  href: $options.yourPledgeUrl,
                  class: "gfu-link _ttl _mt-1",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.onGoToYourPledge && $options.onGoToYourPledge(...args))),
                  "data-qa": "payment-error:ViewYourPledgeButton"
                }, _toDisplayString(_ctx.Resources.Checkout.PaymentErrorViewYourPledgeLabel), 9 /* TEXT, PROPS */, _hoisted_4)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Resources.Checkout.UnauthorizedPaymentErrorBoxDescription), 1 /* TEXT */),
                _createVNode(_component_base_button, {
                  tag: "a",
                  theme: "accent",
                  href: $options.projectUrl,
                  "data-qa": "payment-error:GoToProjectButton"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.PaymentProcessingBoxActionLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"])
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}